import React from "react"

const WebCaption = ({url,text}) => {
  return <span className="caption">Source: <a href={url}> {url}</a></span>
};

export default WebCaption;
